import { FormattedMessage } from 'react-intl';
import { useCheckoutState } from '../../../utils/checkoutState';
import Button from '../../atoms/Button';
import FormattedAddress from '../../atoms/FormattedAddress';
import './style.scss';

type AddressOverviewProps = {
  addressType: 'billing' | 'shipping';
  onChangeClick: () => void;
  showTitle?: boolean;
};

const AddressOverview = ({ addressType, onChangeClick, showTitle }: AddressOverviewProps) => {
  const { checkoutState } = useCheckoutState();

  return (
    <div className="address-overview">
      <Button className="address-overview__btn" onClick={onChangeClick}>
        <FormattedMessage id="generic.change" />
      </Button>
      <FormattedAddress
        address={
          addressType === 'shipping'
            ? checkoutState.orderState.addresses!.shipping!
            : checkoutState.orderState.addresses!.billing!
        }
        title={
          showTitle && (
            <dt className="address-overview__title">
              <FormattedMessage id={`address.${addressType}Address`} />
            </dt>
          )
        }
      />
    </div>
  );
};

export default AddressOverview;
